import { apiClient } from '@features/shared/api/client'
import type {
  SaveTableSidebarOrganizationResponse,
  TableOpenedResponse,
  TableSidebarOrganizationResponse,
  TableSidebarTree,
} from './contracts'

/**
 * GET /users/me/sidebar/tables
 * Returns the user's saved folder structure. Empty folders array on first load.
 */
export async function getTableOrganization(): Promise<TableSidebarOrganizationResponse> {
  const { data } = await apiClient.get<TableSidebarOrganizationResponse>('/users/me/sidebar/tables')
  return data
}

/**
 * PUT /users/me/sidebar/tables
 * Saves the complete folder structure. Backend validates table access,
 * duplicates, parent_id references, etc.
 */
export async function saveTableOrganization(
  organization: TableSidebarTree
): Promise<SaveTableSidebarOrganizationResponse> {
  const { data } = await apiClient.put<SaveTableSidebarOrganizationResponse>(
    '/users/me/sidebar/tables',
    organization
  )
  return data
}

/**
 * PUT /users/me/sidebar/tables/{tableId}/last-opened
 * Stamps the current user's last open of a table, for the Recency sort.
 */
export async function recordTableOpened(tableId: string): Promise<TableOpenedResponse> {
  const { data } = await apiClient.put<TableOpenedResponse>(
    `/users/me/sidebar/tables/${encodeURIComponent(tableId)}/last-opened`
  )
  return data
}
